<template>
  <button :title="title ? title : label" @click="click">
    <slot></slot>
    <span>{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>
